import service from "@/store/services/purchases-deliveries-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  purchasesDelivery: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, purchasesDelivery) => {
    state.purchasesDelivery = purchasesDelivery;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((purchasesDelivery) => {
      commit("SET_RESOURCE", purchasesDelivery);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((purchasesDelivery) => {
      commit("SET_RESOURCE", purchasesDelivery);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((purchasesDelivery) => {
      commit("SET_RESOURCE", purchasesDelivery);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  validate({ commit, dispatch }, params) {
    return service.validate(params, this.$axios).then((purchasesDelivery) => {
      commit("SET_RESOURCE", purchasesDelivery);
    });
  },

  cancel({ commit, dispatch }, params) {
    return service.cancel(params, this.$axios).then((purchasesDelivery) => {
      commit("SET_RESOURCE", purchasesDelivery);
    });
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  purchasesDelivery: (state) => state.purchasesDelivery,
  url: (state) => state.url,
};

const purchasesDeliveries = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default purchasesDeliveries;
